/* eslint-disable no-console */

/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */
let counter = 0;


/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */
/**
 * Generates a random int between a provided min and max number.
 *
 * @param {Number} max The greatest possible number to return.
 * @param {Number} [min=0] Optional param to specify the smallest number to
 *        return. By default this is 0.
 *
 * @returns {Number} A random number between the min and max value (inclusive).
 */
function generateRandomTimeout(max = 2000, min = 10) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}



/* ========================================================================== *\
	EXPORTS
\* ========================================================================== */

/**
 *
 */
export function getAvailability(data = {}) {
	const timeoutDuration = generateRandomTimeout(),
		count = ++counter;

	return new Promise((resolve, reject) => {
		if (data.fail) {
			setTimeout(() => {
				reject();
			}, timeoutDuration);

			return;
		}

		// Iterate over all the days. Mark the first days of the month as
		// available. Only mark the days whose day number equals or is less than
		// the month. IE: September (month 9) will have the first 9 days marked
		// as available.
		data.forEach(day => {
			if (day.isPadding) {
				return;
			}
			// check if day is after or equal to today.
			const currentDate = new Date();
			currentDate.setHours(0, 0, 0, 0);
			day.isAvailable = (day.date >= currentDate);
		});

		setTimeout(() => {
			resolve();
		}, timeoutDuration);
	});
}
